module.exports = __webpack_public_path__ + "static/media/title.a9ce7d11.ogg";